module.exports = __webpack_public_path__ + "img/ons_campaign_0_title.58e2d2c4.png";